import type { SvgIconComponent } from '@mui/icons-material';
import { Icon } from '@ovComponents/1-primative/icon/icon';
import { legacyColors } from '@ovComponents/legacyColor';
import { Box, Typography, type TypographyVariant } from 'hephaestus/web';

type StatusTagProps = {
  size?: 'small' | 'medium';
  label: string;
  color?:
    | 'primary'
    | 'negative'
    | 'warning'
    | 'positive'
    | 'neutral'
    | 'informative';
  icon: SvgIconComponent;
  variant?: TypographyVariant;
  weight?: 'regular' | 'bold';
  right?: boolean;
};

export const StatusTag = ({
  size = 'small',
  label,
  color = 'positive',
  icon,
  variant,
  weight,
  right,
}: StatusTagProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: right ? 'right' : 'flex-start',
    }}
  >
    <Icon
      icon={icon}
      size={size}
      sx={{
        color:
          color === 'neutral' ? legacyColors.neutral600 : legacyColors[color],
        mr: '4px',
      }}
    />
    <Typography
      variant={variant || (size === 'small' ? 'labelSmall' : 'labelLarge')}
      sx={{
        whiteSpace: 'nowrap',
        ...(weight === 'bold' ? { fontWeight: 600 } : {}),
      }}
    >
      {label}
    </Typography>
  </Box>
);
